import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import PVNCalculator from './components/PVNCalculator';

function App() {
  // Redirect /index.html to / for SEO
  useEffect(() => {
    if (window.location.pathname === '/index.html') {
      window.history.replaceState(null, '', '/');
    }
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PVNCalculator />} />
          <Route path="/index.html" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
